<!-- AccessRestrictedMsg -->
<!-- If both rights.userPrivilege and rights.requiredPrivilege are specified, the component will be conditionally rendered -->
<script lang="ts" setup>
    import MessageSection from "./MessageSection.vue"
    import { DisplayStyle } from "../../Enums/UiEnums"
    import { computed } from 'vue';
    import { IUserScreenRights } from '../../lib/Models/User/UserScreenRights';
    import { privilegeName } from '../../lib/Convert/String';


    const props = defineProps<{
        rights?: IUserScreenRights
    }>();

    const rightsHint = computed(() => {
        const parts = [];
        if (props.rights)
        {
            if (props.rights.screen)
                parts.push(`Screen: ${props.rights.screen}`);
            if (props.rights.userPrivilege)
                parts.push(`User privilege level: ${privilegeName(props.rights.userPrivilege)}`);
            if (props.rights.requiredPrivilege)
                parts.push(`Required privilege level: ${privilegeName(props.rights.requiredPrivilege)}`);
        }
        return parts.join(".\n");
    });

    const showMessage = computed(() => {
        if (undefined === props.rights?.requiredPrivilege)
            return false;
        if (undefined === props.rights?.userPrivilege)
            return true;
        return props.rights?.userPrivilege < props.rights?.requiredPrivilege;
    });
</script>

<template>
    <MessageSection :displayStyle="DisplayStyle.Warning" :title="rightsHint" v-if="showMessage">
        <em class="fa-solid fa-shield-halved"></em>

        <slot name="message">
            Insufficient Privileges
        </slot>
    </MessageSection>
</template>

